export const formatPercent = (value: number, decimals = 1) => `${value.toFixed(decimals)} %`;

export const formatTrend = (delta: number) => {
  const sign = delta > 0 ? '+' : '';
  return `${sign}${delta.toFixed(1)} pts`;
};

export const formatCurrency = (value: number, currency = 'EUR') =>
  new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(value);

export const formatCount = (value: number) => new Intl.NumberFormat('fr-FR').format(value);

const MONTHS_FR = ['janv.', 'févr.', 'mars', 'avril', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];

const pad = (n: number) => n.toString().padStart(2, '0');

export const formatAbsoluteDateTime = (iso: string | number) => {
  const d = new Date(iso);
  return `${pad(d.getDate())} ${MONTHS_FR[d.getMonth()]} ${d.getFullYear()} à ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const formatShortDateTime = (iso: string | number) => {
  const d = new Date(iso);
  return `${pad(d.getDate())} ${MONTHS_FR[d.getMonth()]} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

/**
 * Format compact pour table dense (max 12 chars).
 * "12 min", "3 h", "hier", "19 mars", "mars 2025"
 */
export const formatRelativeDate = (iso: string | number, now: Date = new Date()) => {
  const d = new Date(iso);
  const diffMs = now.getTime() - d.getTime();
  const diffMin = Math.floor(diffMs / 60_000);
  const diffH = Math.floor(diffMs / 3_600_000);

  if (diffMin < 1) return 'à l’instant';
  if (diffMin < 60) return `${diffMin} min`;
  if (diffH < 24) return `${diffH} h`;

  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfDate = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const dayDiff = Math.floor((startOfToday.getTime() - startOfDate.getTime()) / 86_400_000);

  if (dayDiff === 1) return 'hier';
  if (d.getFullYear() === now.getFullYear()) {
    return `${pad(d.getDate())} ${MONTHS_FR[d.getMonth()]}`;
  }
  return `${MONTHS_FR[d.getMonth()]} ${d.getFullYear()}`;
};

export const formatFileSize = (bytes: number) => {
  if (bytes < 1024) return `${bytes} o`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} Ko`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
};
